import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { WorkspaceId } from 'honeygrid-types'
import { Connection } from 'honeygrid-types/validators-and-types/ConnectionTypes'

import { dataSourcesQueryKey } from './useDataSources'

interface CreateLiveDataSourceParams {
	workspaceId: WorkspaceId
	name: string
	connectionId: Connection['uuid']
}

interface CreateLiveDataSourceResult {
	success: boolean
	dataSourceId: string
}

/**
 * Hook to create a live data source from an existing connection
 */
export const useCreateLiveDataSource = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()

	return useMutation<CreateLiveDataSourceResult, unknown, CreateLiveDataSourceParams>({
		mutationFn: async ({ workspaceId, name, connectionId }) => {
			const result = await authFetch(`workspaces/${workspaceId}/data-sources`, {
				method: 'POST',
				body: {
					name: name.trim(),
					type: 'connection',
					connection_id: connectionId,
				},
			})

			return {
				success: true,
				dataSourceId: result.id,
			}
		},
		onSuccess: (_data, variables) => {
			// Invalidate data sources list for the workspace
			queryClient.invalidateQueries({
				queryKey: dataSourcesQueryKey(variables.workspaceId),
			})
		},
	})
}
